import styled from 'styled-components'
import logoSmall from '../../assets/forpy-logo-small.svg'
import logo from '../../assets/forpy-logo.png'

export const SiderDesktop = styled.div`
  display: flex;
  position: relative;
  z-index: 100;

  @media (max-width: 760px) {
    display: none;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-x: hidden;
  }

  .ant-layout-sider {
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;

    &.ant-layout-sider-collapsed {
      width: 90px !important;
      max-width: 90px !important;
      min-width: 90px !important;
    }
    .ant-menu-title-content {
      font-size: 1rem;
    }
    .ant-card-body {
      padding: 18px;
    }
    .ant-menu-inline-collapsed >.ant-menu-item {
      padding-inline: 25px;
    }
  }

  .ant-menu-submenu-title {
    padding-inline: 25px !important;
  }

  .version-text {
    text-align: right;
    padding: 4 8;
    font-size: 0.55rem;
    font-weight: 400;
    color: var(--gray);
  }
`

export const SiderMobile = styled.div<{ $isSideMenuOpen: boolean }>`
  display: flex;
  position: relative;
  z-index: 100;

  @media (min-width: 760px) {
    display: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width:  ${({ $isSideMenuOpen }) => ($isSideMenuOpen ? '100vw' : '0')};
    visibility:  ${({ $isSideMenuOpen }) => ($isSideMenuOpen ? 'visibile' : 'hidden')};
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.4);
    /* pointer-events: none; */
    z-index: -1;
    transition: visibility 0.6s ease-in-out;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100dvh;
    overflow-y: auto;
  }
  .ant-layout-sider {
    width: 90vw !important;
    max-width: 90vw !important;
    min-width: 90vw !important;

    &.ant-layout-sider-collapsed {
      width: 0px !important;
      max-width: 0px !important;
      min-width: 0px !important;
    }
    .ant-menu-title-content {
      font-size: 1rem;
    }
    .ant-card-body {
      padding: 18px;
    }
    .ant-menu-inline-collapsed >.ant-menu-item {
      padding-inline: 25px;
    }
  }
  .version-text {
    text-align: right;
    padding: 4 8;
    font-size: 0.55rem;
    font-weight: 400;
    color: var(--gray);
  }
`

export const Logo = styled.div`
    width: 180px;
    aspect-ratio: 637 / 254;
    background-image: url(${logo});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: transparent;
    margin: 0 auto;
`

export const LogoSmall = styled.div`
    width: 40px;
    aspect-ratio: 74 / 54;
    background-image: url(${logoSmall});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: transparent;
    margin: 0 auto;
`
